const Config = {
    config: null,
    set: (config) => {
        Config.config = config;
    }
}

export default Config;